export default function ObjectionTypes() {
  const objections = [
    { title: 'Цена', examples: ['Дорого', 'Нет бюджета', 'У конкурентов дешевле'] },
    { title: 'Время', examples: ['Подумаем', 'Не сейчас', 'Позвоните позже'] },
    { title: 'ЛПР', examples: ['Нужно согласовать', 'Отправьте КП', 'Нужно обсудить с командой'] },
    { title: 'Конкуренты', examples: ['Работаем с другими', 'Нас устраивает текущий поставщик'] },
    { title: 'Потребность', examples: ['Нам это неинтересно', 'Нет времени'] },
    { title: 'Опыт', examples: ['Ранее работали - не понравилось', 'Нет смысла менять'] },
  ];

  return (
    <section id="objections" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие возражения сотрудники научатся обрабатывать
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа охватывает все основные категории возражений, с которыми сталкиваются менеджеры в B2B и B2C продажах.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {objections.map((group, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:bg-teal-50 transition-all duration-300">
              <h3 className="text-xl font-bold text-gray-900 mb-4">{group.title}</h3>
              <div className="space-y-2">
                {group.examples.map((ex, j) => (
                  <div key={j} className="flex items-center gap-2 text-gray-700">
                    <i className="ri-checkbox-circle-line text-teal-600 flex-shrink-0"></i>
                    <span className="text-sm">{ex}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}